<rd-popup-default-template
  [title]="'offer.sort_modal.title' | translate"
  [dialogContent]="dialogContent">
  <ng-template #dialogContent>
    <div role="radiogroup">
      <button
        *ngFor="let option of getOptions()"
        class="option focus-link"
        role="radio"
        [class.selected]="isSelected(option.value)"
        [attr.aria-checked]="isSelected(option.value) ? true : false"
        (click)="onChange(option)">
        <span> {{ option.name | translate }} </span>

        <rd-shared-icon
          *ngIf="isSelected(option.value)"
          class="check-icon"
          [iconSymbol]="'icon-check'"
          [iconTheme]="'primary'"></rd-shared-icon>
      </button>
    </div>
  </ng-template>
</rd-popup-default-template>
